import Box from '@sendsprint/ui-react/dist/components/Box';
import Container from '@src/components/container';
import React from 'react';
import Aside from './components/aside';
import Header, { HeaderProps } from './components/header';
import cs from 'classnames';
import ComplianceReview from './components/complianceReview';
import { Navigate, Outlet } from 'react-router-dom';
import { useBusinessCheckContext } from '@src/contexts/business-check-context';
import Loader from '@src/components/loader';
import useCheckAuthentication from '@src/hooks/utils/useCheckAuthentication';
import IdExpired from './components/idExpired';
import UpdateBusinessAddress from './components/updateBusinessAddress';

export type LoggedInClient = 'receiver' | 'sender' | 'remittance';

interface Props extends HeaderProps {
  client?: LoggedInClient;
  setFixedMainWidth?: boolean;
}

const DashboardLayout = ({ headerContent, client = 'receiver', setFixedMainWidth }: Props) => {
  const { resolvedPath } = useBusinessCheckContext();

  if (resolvedPath) {
    if (resolvedPath === 'loading') return <Loader />;
    return <Navigate to={resolvedPath} replace />;
  }

  return (
    <>
      <Box style={{ backgroundColor: '#F6F8FA' }} className="ss-min-h-screen ss-pb-6">
        <Header headerContent={headerContent} client={client} />
        <Box className="">
          <Container className="ss-flex ss-gap-8">
            <Aside client={client} />
            <Box
              as="main"
              className={cs('ss-w-full lg:ss-flex-1', {
                'lg:ss-w-[600px]': setFixedMainWidth
              })}>
              <IdExpired />
              <ComplianceReview />
              <Box className="ss-py-12">
                <Box>
                  <Outlet />
                </Box>
              </Box>
            </Box>
          </Container>
        </Box>
        <UpdateBusinessAddress />
      </Box>
    </>
  );
};

export default DashboardLayout;
